export default "__VITE_ASSET__D0OcC8l6__"